<template>  
  <div class="productDetail" 
    @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent"
  >
    <mu-appbar class="XR-tab-head fixed" v-if="isScrollImage">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
      <div slot="default" class="head-content">
        <mu-tabs :value="activeTab" @change="handleTabChange">
          <mu-tab value="tab1" title="商品"/>
          <mu-tab value="tab2" title="详情"/>
          <mu-tab value="tab3" @active="handleActive" title="评论"/>
        </mu-tabs>  
      </div> 
      
      <mu-icon-button v-on:click="openShareSheet()" icon=":fa fa-zhuanfa" slot="right" v-if="isApp"/>        
      <mu-icon-menu icon=":fa fa-more" slot="right">
        <mu-menu-item to="/usercenter/index" title="个人中心"/>
        <mu-menu-item to="/" title="首页"/>
        <mu-menu-item to="/retail/cart" title="购物车"/>
      </mu-icon-menu>
    </mu-appbar>
    <mu-appbar class="XR-tab-head fixed aaaa" :style="{opacity: 'opacityValue'}" v-if="!isScrollImage">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
      <div slot="default" class="head-content">
        <div class="recommendImg"><img :src="recommendImage" /></div>
        <div class="recommendText" :style="{width:recommendTextWidth+'px'}">
          <p>好友{{recommendText}}向你推荐{{productInfo.ShopInfo.ShopName}}的{{productInfo.ProductName}}</p>
        </div>
      </div> 
      <mu-icon-button v-on:click="openShareSheet()" icon=":fa fa-zhuanfa" slot="right" v-if="isApp" />
    </mu-appbar>
    <div v-if="activeTab === 'tab1' && !loaded" class="baseInfo">
      <!-- <div class="noticeToLogin" v-if="!isLogin" @click="goLogin()">
        <i class="fa fa-no"></i> 您当前未登录，无法获取分享收益，点击此提示可进入登录页面 
      </div> -->
      <div class="pic-carousel">
        <div class="show-img">
          <XR-swiper ref="swiper">
            <template v-if="productInfo.ImgList && productInfo.ImgList.length>0">
              <XR-slide v-for="(img,index) in productInfo.ImgList" :key=index>
                <img :src="img.ImgPath" :style="{width:fullWidth+'px',height:fullWidth+'px'}" />
              </XR-slide>
            </template>
            <template v-else>
              <XR-slide>
                <img src="/static/index/index-item-default.png" :style="{width:fullWidth+'px',height:fullWidth+'px'}" />
              </XR-slide>
            </template>
          </XR-swiper>        
        </div>
        <!-- <div class="img-count">1/5</div> -->
      </div>   
   
      <div class="pro-activity" v-if="productInfo.DiscountInfo != null" :style="{  backgroundImage:'url('+siteInfo.MobileBgImage+')' }">
        <div class="activity-discountPrice">
          <span class="fontIcon">￥</span>
          <span class="price-num">{{productInfo.DiscountInfo.Price}}</span>
        </div>
        <div class="sale-price">
          <div class="price-num"><span>￥</span><span>{{productInfo.SalePriceName}}</span></div>
          <div class="desc"><i class="fa fa-time"></i>限时优惠</div>
        </div>
        <div class="calc-time">
          <p class="desc">{{calcDesc}}</p>
          <div class="countdown">
            <span class="time">{{hour1}}</span>
            <span class="time">{{hour2}}</span>
            <span class="font">:</span>
            <span class="time">{{mm1}}</span>
            <span class="time">{{mm2}}</span>
            <span class="font">:</span>
            <span class="time">{{ss1}}</span>
            <span class="time">{{ss2}}</span>
          </div>
        </div>
      </div>
      
      <div class="pro-info" v-if="openModel == 'retail'">
        <div class="pro-name">{{productInfo.ProductName}}</div>
        <div class="pro-desc">{{productInfo.SellingPoint}}</div>
        <div class="pro-price" v-if="productInfo.DiscountInfo==null">
          <p class="sale-price">会员价：<i class="fa fa-rmb"></i>{{productInfo.SalePriceName}} <!--<span v-if="productInfo.AwardMoney>0" style="font-size:12px;">/ 分享赚{{productInfo.AwardMoney}}元</span>--></p>
          <p class="del-price">市场价：<i class="fa fa-rmb"></i>{{productInfo.PriceName}}</p>
        </div>
      </div>

      <div class="pro-info" v-if="openModel=='pintuan'">
        <div class="pro-name"> 
          <div class="pro-left">
            <span class="discount-price">{{zhekou(pinTuanInfo.Fprice,productInfo.SalePrice)}}折</span> <span class="cost-price">指导价{{productInfo.SalePrice}}元</span> 
            <p class="pro-title">{{productInfo.ProductName}}</p>
          </div>
          <div class="pro-right">
            <i v-on:click="openShareSheet()" style="font-size: 20px;" class="fa fa-zhuanfa"></i>
          </div>
        </div>
        <div class="pro-desc">{{productInfo.SellingPoint}}</div>
        
        <div class="price-count">
          <template v-if="productInfo.State==0">
            <p class="price">拼团价<span>{{pinTuanInfo.Fprice}}</span>元</p>
            <div class="shopNum sign">{{pinTuanInfo.FgroupNumber}}人团</div>
            <div class="free_post sign" v-if="!productInfo.IsFreight">包邮</div>
            <p class="sellCount">已团{{pinTuanInfo.FcountJoinGroup}}件</p>
          </template>
          <template v-else>
            商品已下架
          </template>
        </div>
      </div>
      <div class="pro-row attr-info" v-if="openModel == 'pintuan'">
          <div class="group-title" :style="{width:proRowContentWidth+'px'}">
            <span>好友团</span> 
            <template v-if="pinTuanInfo.FoldTo=='1'">• 新用户可开团/参团</template>
            <template v-if="pinTuanInfo.FoldTo=='0'">• 新老用户皆可开团/参团></template>            
          </div>
          <div class="pro-icon"><i class="fa fa-angle-right"></i></div>          
      </div>
      <div class="stepImg" v-if="openModel == 'pintuan'"><img src="/static/orderStep.png" alt=""></div>
      <div class="buyCount" v-if="openModel == 'pintuan'">
          每个用户最多购买{{pinTuanInfo.FsingleNum}}件
      </div>
      <div class="goShop" v-if="openModel == 'pintuan' && pinTuanInfo.FgroupList">
        <p class="shop-pro">以下小伙伴正在发起拼团，可直接参与</p>
        <div class="proMessage" v-for="groupItem in pinTuanInfo.FgroupList" :key="groupItem.Fid">
          <div class="clonel">
            <img v-if="groupItem.HeadPic" :src="groupItem.HeadPic" alt="">
            <img v-else src="\static\shangquan\其他.png" alt="">
            <p class="tuanzhang">团长</p>
          </div>
          <div class="name-count">
            <p class="shopName">{{groupItem.UserName}}</p>
            <p class="shopCount">还差<span>{{groupItem.FremainingNum}}</span>人，剩余{{groupItem.FremainingTime}}结束</p>
          </div>
          <div class="shopBtn">
            <mu-flat-button @click="openGroupSheet(groupItem.Fid)" label="去参团" class="demo-flat-button"/>
          </div>
        </div>
      </div>

      <div class="pro-row discount-info" v-if="productInfo.Baw>0 || (productInfo.CandySale && productInfo.CandySale.SalePrice>0)">
        <div class="pro-title">促销</div>
        <div class="pro-content" :style="{width:proRowContentWidth+'px'}">
          <div class="item" v-if="productInfo.Baw>0">                    
            <p class="fontIcon">惠</p>
            <p class="text">可抵扣{{productInfo.Baw}}元</p>
          </div>
          <!-- <div class="item" v-if="productInfo.CandySale && productInfo.CandySale.SalePrice>0">               
            <p class="fontIcon">兑</p>
            <p class="text">{{productInfo.CandySale.SalePrice}}个BAW可全额兑换 <router-link :to="'/baw/orderSubmit?skuId='+productInfo.SkuId">去兑换</router-link></p>
          </div> -->
        </div>
        <!-- <div class="pro-icon"><i class="fa fa-angle-right"></i></div> -->
      </div>
      <div class="pro-row coupon" v-if="navList.length>0 && !closeCoupon">
        <div class="pro-title">领券</div>
        <div class="pro-content" :style="{width:proRowContentWidth+'px'}" @click="openCouponSheet">
          <template v-if="navList.length>3" v-for="key in 3">
              <span class="discount-coupon">满{{ navList[key].FullMoney}}减{{navList[key].Money}}</span>
          </template>
          <template v-else v-for="item in navList">
              <span class="discount-coupon">满{{ item.FullMoney}}减{{item.Money}}</span>
          </template> 
        </div>
        <div class="pro-icon"><i class="fa fa-angle-right"></i></div>     
      </div>
      <mu-bottom-sheet class="couponSheet" :open="couponSheet" @close="closeCouponSheet">    
        <div class="coupon_sec_body">
          <div  v-for="couponRow in navList" :key="couponRow.id" class="coupon_default_inner"> 
            <template > 
              <div :class="(percent(couponRow.ReceiveAmount/couponRow.TotalAmount) >=100 ? 'couponGrey' : (couponRow.Type== 0? 'couponRink':'couponYellow'))" class="couponLeft">
                  <div class="coupon_discount" >
                      <p class="cost">￥</p>
                      <p class="money">{{couponRow.Money}}</p>
                  </div>
              </div>
              <div class="couponRight" :class="(percent(couponRow.ReceiveAmount/couponRow.TotalAmount) >=100 ? 'couponGrey' : (couponRow.Type==0? 'couponRink':'couponYellow'))">              
                <div class="coupon_content" :style="{width:couponWidth+'px'}">
                  <p class="coupon_title">
                    <span class="coupon_type">{{couponRow.TypeName}}</span> {{couponRow.Name}}
                  </p>
                  <p class="limit">
                      使用门槛：满{{couponRow.FullMoney}}元可用
                      <span v-if="couponRow.state=='已领取'" style="float: right;margin-right: 14px;">已领取</span>
                  </p>
                  <div class="coupon_progress">
                    <mu-linear-progress mode="determinate" :value="percent(couponRow.ReceiveAmount/couponRow.TotalAmount)"/>
                    <span class="percent">{{percent(couponRow.ReceiveAmount/couponRow.TotalAmount)+'%'}}</span>
                    <mu-flat-button  v-if="percent(couponRow.ReceiveAmount/couponRow.TotalAmount) !=100 && couponRow.MemberTotalReceiveAmount <= couponRow.EveryoneAmount && couponRow.ReceiveStatus !=1"  @click="btnClick(couponRow.Id)" label="点击领取" class="demo-flat-button" primary/>
                    <mu-flat-button  v-if="couponRow.ReceiveStatus==1" @click="goToCouponUsing(couponRow.Id)" label="去使用" class="demo-flat-button" primary/>
                    <span v-if="percent(couponRow.ReceiveAmount/couponRow.TotalAmount)==100 && couponRow.ReceiveStatus==0" class="coupon_empty">已抢光</span>
                  </div>               
                </div>
              </div>
            </template>
          </div>
      </div>
      </mu-bottom-sheet>

      <div class="pro-row attr-info" v-if="false">
        <div class="pro-title">已选</div>
        <div class="pro-content" :style="{width:proRowContentWidth+'px'}" @click="openAttrSheet">
          <div class="item strone">
            <template v-for="attr in productInfo.AttrList">
              <template v-for="attrValue in attr.Values">
                <span v-if="attrValue.IsSkuValue>0">{{attrValue.Name}}，</span>
              </template>
            </template>
            数量：{{skuCount}}</div>
        </div>
        <div class="pro-icon"><i class="fa fa-angle-right"></i></div>        
      </div>
      <div class="pro-row delivery-info">
        <div class="pro-title">送至</div>
        <div class="pro-content" :style="{width:proRowContentWidth+'px'}">
          <div class="item" @click="openBottomSheet">
            <i class="fa fa-mydinwei1"></i>
            <span>{{deliveryAddress}}</span>
          </div>
          <mu-divider style="background: #f5f5f5;margin-left: -40px;" :style="{width:fullWidth+'px'}"/>
          <div class="item" @click="openBottomSheet">
            <i class="fa fa-myyoufei1"></i>
            <span>邮费：{{deliveryMoney}}元</span>
          </div>
          <mu-divider v-if="isZiTi" style="background: #f5f5f5; margin-left: -40px;" :style="{width:fullWidth+'px'}"/>
          <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">            
            <mu-picker :slots="addressSlots" :visible-item-count="5" @change="addressChange" :values="address" @itemClick="closeBottomSheet"/>
          </mu-bottom-sheet>
          <div class="item" v-if="isZiTi">
                <i class="fa fa-map-o" ></i>
               <span>支持自提:<mu-raised-button label="查询自提点" @click="open('bottom')" class="demo-raised-button"/></span>           
          </div>
          <mu-popup  position="bottom" popupClass="demo-popup-bottom" :open="bottomPopup" @close="close('bottom')">
            <div class="selfPickUpShopList">              
              <mu-list-item v-if="selfPickUpList.length>0" v-for="selfPickUpItem in selfPickUpList" :key="selfPickUpItem.ShopId">
                  <div class="item-content">
                      <p class="name">{{selfPickUpItem.ShopName}}</p>
                      <p class="address">{{selfPickUpItem.Address}}</p>
                      <p class="phone">{{selfPickUpItem.ContactPerson}} {{selfPickUpItem.ContactPhone}}</p>
                  </div>
              </mu-list-item>
              <mu-list-item v-if="selfPickUpList.length==0">
                {{selfPickUpListDesc}}
              </mu-list-item>
            </div>
          </mu-popup>
        </div>
        <div class="pro-icon"><i class="fa fa-angle-right"></i></div>
      </div>
      <div class="id-shop">
        <div class="logo">
            <img :src="productInfo.ShopInfo.Logo" class="shopLogoImg">
            <p class="shop-name">{{productInfo.ShopInfo.ShopName}}</p>
        </div>
        <div class="total-count">
            <div class="item border">
                <p class="num" id="productCount">{{productInfo.ShopInfo.ProductCount}}</p>
                <p class="desc">全部商品</p>
            </div>
            <div class="item">
                <p class="num" id="guanzhuCount">{{productInfo.ShopInfo.GuanzhuCount}}</p>
                <p class="desc">关注人数</p>
            </div>
        </div>
        <div class="shop-btns">
            <div class="btn-item" @click="FavStore(productInfo.ShopInfo.ShopId)" v-if="!shopFavState"><span class="link-btn"><i class="fa fa-aixin"></i> 关注商家</span></div>
            <div class="btn-item" @click="UnFavStore(productInfo.ShopInfo.ShopId)" v-if="shopFavState"><span class="link-btn"><i class="fa fa-aixin"></i> 已关注</span></div>
            <router-link :to="productInfo.ShopInfo.ShopType==1?'/':'/shop/shopIndex?shopId='+productInfo.ShopInfo.ShopId" class="jdgg">
              <div class="btn-item">
                <span class="link-btn" style="border: 1px solid #dedede;"><i class="fa fa-house1"></i>  进店逛逛</span>
              </div>
            </router-link>
            <div class="btn-item"><span class="link-btn"><i class="fa fa-brand"></i> 商家资质</span></div>
        </div>
      </div>
      <div class="productDetailImgInfo" v-if="productInfo.PcDetail" v-html="productInfo.PcDetail"></div>
      <div class="specListDiv" v-if="productInfo.SpecList && productInfo.SpecList.length>0">
        <p class="specListTitle">产品规格</p>
        <table class="specList" cellspacing="0" cellspadding="0">
          <tr v-for="specItem in productInfo.SpecList" :key="specItem.AttrId">
            <td class="specItemName">{{specItem.AttrName}}</td>
            <td class="specItemValue">
              <template v-for="valueItem in specItem.ValueList">
                {{valueItem.AttrValueName}}
              </template>
            </td>
          </tr>
        </table>
      </div>
      <mu-tabs :value="activeThreeTab" @change="handleThreeTabChange">
        <mu-tab :value="0" :title="'全部 '+evaluateCount.TotalCount"/>
        <mu-tab :value="1" :title="'好评 '+evaluateCount.Good"/>
        <mu-tab :value="2" :title="'中评 '+evaluateCount.Middler"/>
        <mu-tab :value="3" :title="'差评 '+evaluateCount.Bad"/>
        <mu-tab :value="4" :title="'有图 '+evaluateCount.WithImage"/>
      </mu-tabs>  
      <div class="id-sumary">
        <ul v-if="evaluateList.Evaluates">
          <li v-for="evaluateItem in evaluateList.Evaluates">
            <div  class="timg" :style="{height: timgHeight +'px'}">
                <img :src="evaluateItem.PjUserHeadpic" alt="">
            </div> 
            <span class="nametime">{{evaluateItem.PjUserName}}</span>
            <span class="time">{{evaluateItem.PjDateName.split(' ')[0]}}</span>
            <div class="xing-div">
              <span class="fa fa-star" v-for="i in evaluateItem.StarLevel"></span>
            </div>
            <p class="content">{{evaluateItem.PjContent}}</p>
            <div class="pj-img-list">                
              <div class="dimg" :style="{height:dimgWidth+'px'}" v-for="imgItem in evaluateItem.Images" :key="imgItem.Id" >
                <img :src="imgItem.ImgPath" @click="goToEvaluateImg(skuId,imgItem.Id)" />
              </div> 
            </div>
            <template v-if="evaluateItem.HfUserName">              
              <span class="nametime" style="margin-top:10px;">
              <span style="color: red;">{{evaluateItem.HfDateName.split(' ')[0]}} 商家回复：</span>{{evaluateItem.HfUserName}} </span>
              <p class="content">{{evaluateItem.HfContent}}</p>
            </template>
            <mu-divider />
          </li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount>15" @click="goToEvaluatePage()">查看更多</li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount<=15">暂无更多</li>
        </ul>
		<ul v-else-if>
		  <template>
            <li style="text-align:center; font-size:12px; color:#999;" v-if="!(evaluateCount.TotalCount > 0 && activeThreeTab == 0) && !(evaluateCount.Good > 0 && activeThreeTab == 1) && !(evaluateCount.Middler > 0 && activeThreeTab == 2) && !(evaluateCount.Bad > 0 && activeThreeTab == 3) && !(evaluateCount.WithImage > 0 && activeThreeTab == 4)">暂无评论</li>
          </template>
		</ul>
      </div>
    </div>
    <div v-if="activeTab === 'tab2' && !loaded" class="productDetailInfo" :style="{height:fullHeight+'px'}">
      <mu-tabs :value="activeSubTab" @change="handleSubTabChange">
        <mu-tab value="subTabl" title="商品介绍"/>
        <mu-tab value="subTab2" title="规格参数"/>
        <mu-tab value="subTab3" title="包装售后"/>
      </mu-tabs>  
      
      <div v-if="activeSubTab === 'subTabl'" class="fontImgInfo" >
        <span v-html="productInfo.PcDetail"></span>
      </div>
      <div v-if="activeSubTab === 'subTab2'" class="skuAttrInfo">
        <table class="specList" cellspacing="0" cellspadding="0">
          <tr v-for="specItem in productInfo.SpecList" :key="specItem.AttrId">
            <td class="specItemName">{{specItem.AttrName}}</td>
            <td class="specItemValue">
              <template v-for="valueItem in specItem.ValueList">
                {{valueItem.AttrValueName}}
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="activeSubTab === 'subTab3'" class="productDetailServiceInfo">
        <div>
          <div class="shoppromise">
            <h6>1、挑选商品</h6>
            <p>“{{siteInfo.SiteName}}”为您提供了方便快捷的商品引导及搜索功能：</p>
            <p>1) 通过搜索功能输入关键字的方法查找您想要购买的商品。</p>
            <p>2) 通过分类或者品牌导航查看并找到您想要购买的商品</p> 
          </div>
          <div class="shoppromise">
            <h6 class="blur">2、加入购物车</h6>
            <p>在您想要购买商品的详情页点击“加入购物车”，商品会添加到您的购物车中；您还可以继续挑选商品放入购物车，一起结算。</p>
            <p>1) 在购物车中，系统默认没见商品的订购数量为1件，如果您想购买多件商品，可修改购买数量。</p>
            <p>2) 在购物车中，您可以将商品删除。</p> 
            <p>3) 在购物车中，您可以直接查看到订单享受的优惠和优惠金额。</p> 
            <p>温馨提示：</p> 
            <p>1)商品价格会随着市场行情调整，当您看中某款商品时，请及时入手。</p> 
            <p>2)优惠政策、配送时间、支付方式等都有可能进行调整，请随时关注网站公布的最新信息。</p> 
          </div>
          <div class="shoppromise">
            <h6>3、确认购买</h6>
            <p>当您挑选好需购买的商品后，点击购物车中的“去结算”按钮跳转至订单信息页面。</p>
            <p>若您未登录，则出现登录框：</p>
            <p>老顾客：请在页面输入用户名和密码登录即可。</p> 
            <p>新顾客：点击页面的“立即注册”进行注册，注册成功后自动跳转至订单信息页。</p>
          </div>
          <div class="shoppromise">
            <h6 class="blur">4、填写订单信息</h6> 
            <p>1)确认收货信息：收货人姓名，地址及电话等信息。</p>
            <p>请填写正确完整的收货人姓名、收货人联系方式，详细的收货地址和邮编，否则将会影响您订单的处理或者配送。您可以进入“个人中心 - 账户管理” 设置默认收货地址，保存成功后，再订购时，可以直接选择使用。</p> 
            <p>2)确认配送方式：确认详细的配送方式、送达时间等信息。</p>
            <p>3)确认支付方式：选择合适您的支付方式。住：目前提供在线支付、银行汇款、货到付款、到店自提、分期付款。</p>
            <p>4)索取发票：填写正确的发票抬头、选择正确的发票内容，发票选择成功后，将于订单货物一起送到 。</p>
            <p>5)确认商品清单：确认购买商品的品类、数量、价格、金额及促销、优惠等信息。</p>
          </div>
          
          <div class="shoppromise">
            <h6>5、提交订单、商品结算</h6>
            <p>1)以上信息核实无误后，请点击“提交订单”，系统生成一个订单号，提示您已经成功提交订单。</p>
            <p>2)订单提交成功后，您可以登录“我的账户-订单中心”管理订单信息。</p> 
          </div>
          <div class="shoppromise">
            <h6 class="blur">6、订单状态</h6>
            <p>待审核：订单提交成功后，等待客服确认订单信息。</p>
            <p>审核通过：订单审核成功，客服为您安排发货。</p> 
            <p>已发货：订单商品已经从库房发出，配送人员已经出发。</p> 
            <p>已签收：买家已签收为您配送的商品。</p> 
            <p>拒签收，由于特殊原因，买家决绝签收包裹。</p> 
            <p>已完成：订单被正常签收或者部分收货，此订单正常流转完成。</p> 
            <p>已取消：订单有用户主动取消或者系统自动取消。</p> 
          </div>
          <div class="shoppromise">
            <h6>电话订购：</h6>
            <p>您可以直接从“{{siteInfo.SiteName}}”上挑选您喜欢的商品，然后拨打我们的贵宾专线，把商品编号告诉客服，我们将协助您完成商品购买。</p> 
          </div>
          <div class="shoppromise gray"> 
              <p>贵宾专线：{{siteInfo.Phone}}</p>
              <p>客服工作时间：{{siteInfo.ServiceTime}}</p>
              <p>客服邮箱：{{siteInfo.Email}}</p> 
          </div>
          <div class="clearfix"></div>  
        </div>
      </div>
    </div>
    <div v-if="activeTab === 'tab3' && !loaded" class="productDetailEvalue" :style="{minHeight:fullHeight+'px'}">
      <mu-tabs :value="activeThreeTab" @change="handleThreeTabChange">
        <mu-tab :value="0" :title="'全部 '+evaluateCount.TotalCount"/>
        <mu-tab :value="1" :title="'好评 '+evaluateCount.Good"/>
        <mu-tab :value="2" :title="'中评 '+evaluateCount.Middler"/>
        <mu-tab :value="3" :title="'差评 '+evaluateCount.Bad"/>
        <mu-tab :value="4" :title="'有图 '+evaluateCount.WithImage"/>
      </mu-tabs> 
      <div class="id-sumary">
        <ul v-if="evaluateList.Evaluates">
          <li v-for="evaluateItem in evaluateList.Evaluates">
            <div :style="{height: timgHeight +'px'}" class="timg">
                <img  :src="evaluateItem.PjUserHeadpic"  alt="">
            </div> 
            <span class="nametime">{{evaluateItem.PjUserName}}</span>
            <span class="time">{{evaluateItem.PjDateName.split(' ')[0]}}</span>
            <div class="xing-div">
              <span class="fa fa-star" v-for="i in evaluateItem.StarLevel"></span>
            </div>
            <p class="content">{{evaluateItem.PjContent}}</p>
            <div class="pj-img-list">
                <div class="dimg" :style="{height:dimgWidth+'px'}" v-for="imgItem in evaluateItem.Images" :key="imgItem.Id" >
                  <img :src="imgItem.ImgPath" @click="goToEvaluateImg(skuId,imgItem.Id)" />
                </div>            
            </div>
            <template v-if="evaluateItem.HfUserName">              
              <span class="nametime" style="margin-top:10px;">
              <span style="color: red;">{{evaluateItem.HfDateName.split(' ')[0]}} 商家回复：</span>{{evaluateItem.HfUserName}} </span>
              <p class="content">{{evaluateItem.HfContent}}</p>
            </template>
            <mu-divider />
          </li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount>15" @click="goToEvaluatePage()">查看更多</li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount<=15">暂无更多</li>
        </ul>
		<ul v-else-if>
		  <template>
            <li style="text-align:center; font-size:12px; color:#999;" v-if="!(evaluateCount.TotalCount > 0 && activeThreeTab == 0) && !(evaluateCount.Good > 0 && activeThreeTab == 1) && !(evaluateCount.Middler > 0 && activeThreeTab == 2) && !(evaluateCount.Bad > 0 && activeThreeTab == 3) && !(evaluateCount.WithImage > 0 && activeThreeTab == 4)">暂无评论</li>
          </template>
		</ul>
      </div>
    </div>

    <mu-bottom-sheet :open="shareSheet" @close="closeShareSheet">    
      <div class="productDetailPage-shareSheetTitle">分享到</div>
      <div class="productDetailPage-shareSheetWayList">
        <div class="shareSheetWayItem" @click="appWeChatFringtShareClick">
          <div class="shareWayIcon wechatFrind"><i class="fa fa-wechat"></i></div>
          <div class="shareWayText">微信好友</div>
        </div>
        <div class="shareSheetWayItem" @click="appWeChatFringtQuanShareClick">          
          <div class="shareWayIcon wechatFrindQuan"><i class="fa fa-diamonds"></i></div>
          <div class="shareWayText">朋友圈</div>
        </div>
      </div>   
    </mu-bottom-sheet>

    <mu-bottom-sheet :open="GroupSheet" @close="closeGroupSheet">    
      <div class="productDetail-skuSaleInfo">
        <div class="pro-img">          
          <img :src="productInfo.SkuImage" class="img" v-if="productInfo.SkuImage" />
          <img :src="productInfo.ImgList[0].ImgPath" class="img" v-else-if="productInfo.ImgList" />
          <img :src="IMGServer_URL+'/images/index-item-default.png'" class="img" v-else/>
        </div>
        <div class="info" v-if="openModel =='retail'">
          <p class="price">￥{{productInfo.DiscountInfo == null ? productInfo.SalePriceName :productInfo.DiscountInfo.Price}}</p>
          <p class="stock">库存：{{productInfo.DiscountInfo == null ? productInfo.Stock :productInfo.DiscountInfo.Stock}}</p>
        </div>
        <div class="info" v-if="openModel =='pintuan'">
          <p class="price">￥{{pinTuanInfo.Fprice}}</p>
          <p class="stock">库存：{{pinTuanInfo.Fstock}}</p>
        </div>
      </div>   
      <div style="clear:both;"></div>  
      <div class="productDetail-scroll">            
        <div class="productDetail-attrList">            
          <div class="attr" v-for="attr in productInfo.AttrList" :key="attr.Id">
            <div class="attrName">{{attr.Name}}</div>
            <div class="attrValueList pintuanAttr">
              <div :class="'attrValue '+getSkuClassSelect(attr.Id,attrValue.Id,attrValue.Name) +' '+getPintuanSku(attrValue.SkuIdList)" v-for="attrValue in attr.Values" :key="attrValue.SkuId" @click="skuTab(attr.Id,attrValue.Id,attrValue.Name)">
                <template v-if="attr.AttrType==1 && attrValue.IconPath"><img :src="imgServerUrl+'/api/img/getPath?id='+attrValue.IconPath" class="attrIcon" /></template>
                <template v-if="attr.AttrType==3 && attrValue.Color"><span class="attrIcon" :style="{background:attrValue.Color}" ></span></template>
                <span class="attrValueText">{{attrValue.Name}}</span>
              </div>
            </div>
          </div>
        </div>   
        <div class="productDetail-jiajian">
          <div class="tip" v-show="tipShow">
              活动商品限购{{pintuanMaxnum}}件
          </div>
          <div class="productDetail-jiajian-ctrl">
            <span class="btn jian" @click="minusCartItem(productInfo.SkuId, productInfo.Stock)">-</span>
            <span class="count">{{skuCount}}</span>
            <span class="btn jia" @click="plusCartItem(productInfo.SkuId, productInfo.Stock)">+</span>
          </div>
        </div>
      </div>
      <div v-if="botton==2" class="productDetail-btn" @click="joinGroup()">            
        <div class="btn">我要参团</div>
      </div>
      <div v-if="botton==1" class="productDetail-btn" @click="openGroup()">
        <div class="btn">我要开团</div>
      </div>
    </mu-bottom-sheet>

    <mu-bottom-sheet :open="attrSheet" @close="closeAttrSheet">    
      <div class="productDetail-skuSaleInfo">
        <div class="pro-img">
          <img :src="productInfo.SkuImage" class="img" v-if="productInfo.SkuImage" />
          <img :src="productInfo.ImgList[0].ImgPath" class="img" v-else-if="productInfo.ImgList" />
          <img :src="IMGServer_URL+'/images/index-item-default.png'" class="img" v-else/>
        </div>
        <div class="info">
          <p class="price">￥{{productInfo.DiscountInfo == null ? productInfo.SalePriceName :productInfo.DiscountInfo.Price}}</p>
          <p class="stock">库存：{{productInfo.DiscountInfo == null ? productInfo.Stock :productInfo.DiscountInfo.Stock}}</p>
        </div>
      </div>   
      <div style="clear:both;"></div>  
      <div class="productDetail-scroll">            
        <div class="productDetail-attrList">            
          <div class="attr" v-for="attr in productInfo.AttrList" :key="attr.Id">
            <div class="attrName">{{attr.Name}}</div>
            <div class="attrValueList">
              <div :class="'attrValue '+getSkuClassSelect(attr.Id,attrValue.Id,attrValue.Name)+' '+getPintuanSku(attrValue.SkuIdList)" v-for="attrValue in attr.Values" :key="attrValue.Id" @click="skuTab(attr.Id,attrValue.Id,attrValue.Name)">
                <template v-if="attr.AttrType==1 && attrValue.IconPath"><img :src="imgServerUrl+'/api/img/getPath?id='+attrValue.IconPath" class="attrIcon" /></template>
                <template v-if="attr.AttrType==3 && attrValue.Color"><span class="attrIcon" :style="{background:attrValue.Color}" ></span></template>
                <span class="attrValueText">{{attrValue.Name}}</span>
              </div>
            </div>
          </div>
        </div>   
        <div class="productDetail-jiajian">
          <div class="productDetail-jiajian-ctrl">
            <span class="btn jian" @click="minusCartItem(productInfo.SkuId, productInfo.Stock)">-</span>
            <span class="count">{{skuCount}}</span>
            <span class="btn jia" @click="plusCartItem(productInfo.SkuId, productInfo.Stock)">+</span>
          </div>
        </div>
      </div>
      <div class="productDetail-btn">            
        <div class="btn" @click="joinCart" v-if="attrSheetType==1">加入购物车</div>
        <div style="overflow:hidden;" v-if="attrSheetType==2">
          <template v-if="productInfo.IsBuyBawAuth">
            <div class="btn" style="width:50%; float:left; background:#FF9500;" @click="goBawBuy">BAW兑换</div>
            <div class="btn" style="width:50%; float:left;" @click="goBuy">原价购买</div>
          </template>
          <template v-if="!productInfo.IsBuyBawAuth">
            <div class="btn" @click="goBuy">原价购买</div>
          </template>
        </div>
      </div>
    </mu-bottom-sheet>

    <div class="productDetailBottomButton">
      <div class="content pintuanBtn"  v-if="openModel == 'pintuan'">
        <router-link to="/groupShop/groupShopList" class="btn"><i class="fa fa-zhuye"></i><p>拼团首页</p></router-link>       
        <div class="btn group-price" @click="openGroupSheet2(3)">
            <i class="fa fa-rmb"></i><span>{{pinTuanInfo.Fprice}}</span><p>{{pinTuanInfo.FgroupNumber}}人团</p>
        </div>
        <div :class="favState?'btn ':'btn'" @click="openAttrSheet(2)" ><i class="fa fa-rmb"></i><span>{{productInfo.SalePrice}}</span><p>单独购买</p></div>
      </div>
     <div class="content" v-if="openModel == 'retail'">
        <router-link :to="productInfo.ShopInfo.ShopType==1?'/':'/shop/shopIndex?shopId='+productInfo.ShopInfo.ShopId"><div class="btn"><i class="fa fa-house1"></i><p>店铺</p></div></router-link>
        <div :class="favState?'btn faved':'btn'" @click="favClick"><i class="fa fa-aixin"></i><p>收藏</p></div>
        <div class="btn">
          <router-link to="/retail/cart">
            <mu-badge :content="cartCount" circle secondary badgeClass="msg-badge">
              <i class="fa fa-shopping-cart2"></i><p>购物车</p>
            </mu-badge>
          </router-link></div>
      </div>
      <div class="btn-list" v-if="openModel == 'retail'">        
        <div class="btn" @click="openAttrSheet(1)">加入购物车</div>
        <div class="btn" @click="openAttrSheet(2)">立即购买</div>
        <!--<div class="btn" style="width:100%;" @click="showPayImg()">立即购买</div>-->
      </div>
    </div>
    <div class="payLayer" v-if="showPayLayer">
      <div class="payLayerBg" @click="closePayLayer()"></div>
      <div class="payLayerContent">
        <div class="qrBtn" @click="closePayLayer()">
          <img src="/static/icon/close.png" />
        </div>
        <img src="/static/sansanpay.png" class="qrcode" />
        <p>请扫码进行支付</p>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/cart'
import appShare from '../../util/appShare'
import siteconfig from '../../util/siteconfigCache'
import wechatCache from '../../util/wechatCache'
var address = {
  '北京': {'北京':['北京']},
  '湖北': {'武汉':['武昌区','汉阳区','青山区']},
  '台湾': {'台北市':['台北市']}
}

export default {
  name : 'XR-tab-head',
  data () {
    return {
      bottomPopup: false,
      activeTab: 'tab1',
      activeSubTab: 'subTabl',
      activeThreeTab: 0,
      evaluateList:[],
      evaluateCount : {
        TotalCount:0, 
        Good:0,
        Middler:0,
        Bad:0,
        WithImage:0
      },
      scrollTop:document.documentElement.scrollTop,
      fullWidth : document.documentElement.clientWidth,
      dimgWidth : (document.documentElement.clientWidth-16)*0.32,
      timgHeight:  (document.documentElement.clientWidth-16)*0.09,
      fullHeight: (parseInt(document.documentElement.clientHeight)-48),
      proRowContentWidth: (parseInt(document.documentElement.clientWidth)-100),
      bottomSheet: false,
      attrSheet:false,
      attrSheetType: 1,
      couponSheet:false,
      GroupSheet:false,
      selectAddress:'',
      addressSlots: [
        {
          width: '100%',
          textAlign: 'right',
          values: ['北京']
        }, {
          width: '100%',
          textAlign: 'center',
          values: ['北京市']
        }, {
          width: '100%',
          textAlign: 'left',
          values: ['东城区']
        }
      ],
      address: ['全部', '全部','全部'],
      addressProvince: '全部',
      addressCity: '全部',
      addressArea: '全部',
      deliveryAddress:'请选择送货区域',
      loaded:true,
      productInfo:{
        ShopInfo:{},
        IntegralSale:{}
      },
      skuTabList:[],
      skuId:this.$route.query.skuId,
      skuCount:1,
      cartCount:'0',
      favState : false,
      shopFavState : false,
      SessionId:this.$store.state.user.SessionId,      
      startTime :'',
      endTime:'',
      calcDesc:'',
      buynowInterval :0,
      hour1:'0',
      hour2:'0',
      mm1:'0',
      mm2:'0',
      ss1:'0',
      ss2:'0',
      datalock:false,
      deliveryMoney:0,
      imgServerUrl : this.IMGServer_URL,
      isZiTi: false,
      selfPickUpList:[],
      selfPickUpListDesc:'请选择区域',      
      siteInfo: {},
      isScrollImage: false,
      recommendImage:'http://frontend.xurigo.com/icon/person.jpg',
      recommendText:'',
      recommendTextWidth:document.documentElement.clientWidth-48-16-30-10-48,
      shareSheet:false,
      shareTitle:'',
      shareDesc:'',
      shareImgUrl:'',
      shareLinkUrl:'',
      isApp:false,
      scrollDone:function(){},
      openModel:'retail',
      activityId: this.$route.query.activityId,
      pinTuanInfo:{},
      joinGroupId :0,
      ulWidth: document.documentElement.clientWidth-99,
      bg3:'../../../../static/coupon/couponCenter1-3.png',
      couponWidth: document.documentElement.clientWidth-20-60-16,
      pintuanMaxnum:0,
      pintuanClass:'',
      botton:1,
      tipShow:false,
      pintuanSkuId:[],
      timer:'',
      couponInfo:{
        skuId:this.$route.query.skuId,
        ShopId:'',
        ActivityType:0,
        ProductId:'',
      },
      navList:{},
      canTabSkuList:[],
      isLogin: false,
      skuTabMode: 'select',
      showPayLayer: false
    }
  },
  created(){
    window.openShare= this.openShare
  },
  mounted(){
    var url = window.location.href
    if(/[?]from=(.)*#/.test(url)){
      url = url.replace(/[?]from=(.)*#/g , "#")
      window.location.href = url
      return
    }
    this.$refs.XRtoast.load()

    if (this.$store.state.user.SessionId) {
      this.isLogin =true
    }

    var appClient = window.localStorage.appClient
        if(appClient == 'android' || appClient == 'ios'){
        this.isApp = true
    }
    if(!this.$route.query.memberId){
      this.isScrollImage = true
    }
    this.getProductDetail()
    this.getRecommendInfo() 
    this.getCartCount()
    this.getFavState()
    this.getAreaList()  
    this.getDeliveryAreaCache()  
    this.AddProductSkuBrowserCount()
    this.getPintuanSkuid()
  },

  methods: {  
    showPayImg(){
      this.showPayLayer = true
    }, 
    closePayLayer(){
      this.showPayLayer = false
    },
    touchEvent () {
      if(this.$route.query.memberId){
        if(this.activeTab == 'tab1'){
          var scrollTop = this.$el.scrollTop
          var opacityValue=1- this.$el.scrollTop/this.fullWidth
          document.querySelector('.aaaa').style.opacity=opacityValue
          if(scrollTop>=this.fullWidth){
            this.isScrollImage =true
          }else{
            this.isScrollImage =false
          }
        }else{
          this.isScrollImage =true
        }
      }
    
    }, 
    percent(obj){
      return (obj * 100).toFixed(2);
    },
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.siteInfo = res.Data;
          siteconfig.addSiteconfig(res.Data)
            
          ths.getUserInfo() 
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    open (position) {
      if(position=='bottom'){
        if(this.isZiTi){          
          this.GetSelfPickUpSiteShopList()
        }
      }
      this[position + 'Popup'] = true
    },
    close (position) {
      this[position + 'Popup'] = false
    },
    WapCouponListByGoods(){
      const ths = this;
      ths.$post("/Shop/CouponServer/WapCouponListByGoods",
        JSON.stringify(this.couponInfo)
      ).then(function(res){
        if(res.IsSuccess){
          ths.navList = res.Data
        }
      })
    },
    AddProductSkuBrowserCount(){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/AddProductSkuBrowserCount",{skuId:this.skuId}
      ).then(function(res) {
      });
    },
    getDeliveryAreaCache(){      
      var provinceCache = window.localStorage.ProductDetailDeliveryProvinceCache
      if(provinceCache){
        this.addressProvince = provinceCache
      }
      var cityCache = window.localStorage.ProductDetailDeliveryCityCache
      if(cityCache){
        this.addressCity = cityCache
      }
      var areaCache = window.localStorage.ProductDetailDeliveryAreaCache
      if(areaCache){
        this.addressArea = areaCache
      }
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
    },
    getFavState: function(){
      if(this.SessionId){
        var ths = this;   
        ths.$post(
          "/Shop/RetailServer/GetFavoriteState",
          JSON.stringify({skuId:this.skuId})
        ).then(function(res) {
          ths.favState = res.IsSuccess
        });
      }
    },
    favClick(){
      if(this.favState){
        this.cancelFav()
      }
      else{
        this.addFav()
      }
    },
    btnClick(num){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
		this.$router.push(this.loginUrl+"?redirect="+encodeURIComponent(this.$router.history.current.fullPath)+"&msg="+encodeURIComponent("请先登录再领券"));
        return;
      }else{
        var ths = this;
        ths.$post('/Shop/CouponServer/WapReceiveCoupon',{'CouponId':num}
        ).then(function (res) {
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{
            ths.WapCouponListByGoods()
          }
          })
      }
    },
    addFav(){
      if(this.SessionId){
        var ths = this;   
        ths.$post(
          "/Shop/RetailServer/AddFavorite",
          JSON.stringify({skuId:this.skuId})
        ).then(function(res) {
          ths.favState = res.IsSuccess
          ths.$refs.XRtoast.success(res.Msg, true)
        });
      }
      else{
        this.$refs.XRtoast.failed("未登录", true);
      }
    },
    cancelFav(){      
      if(this.SessionId){
        var ths = this;   
        ths.$post(
          "/Shop/RetailServer/CancelFavoriteBatch",
          JSON.stringify({skuIds:[this.skuId]})
        ).then(function(res) {
          if(res.IsSuccess){
            ths.favState = false
            ths.$refs.XRtoast.success(res.Msg, true)
          }
        });
      }
      else{
        this.$refs.XRtoast.failed("未登录", true);
      }
    },
    getAreaList(){
      var ths = this;   
      ths.$post(
        "/Shop/BaseServer/GetAreaAllListGroup"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{     
          address= JSON.parse(res.Data) 
          ths.addressSlots[0].values = Object.keys(address)   
          
          if(ths.$route.query.id){ 
            ths.getInfo()
          }else{
            // ths.loaded = false
            // ths.$refs.XRtoast.hide()
          }    
        }
      });
    },    
    addressChange (value, index) {
      switch (index) {
        case 0:
          this.addressProvince = value
          var cirtyList = address[value]
          var keys = Object.keys(cirtyList)          
          this.addressSlots[1].values = keys
          this.addressCity = keys[0]
          
          var areaList = address[this.addressProvince][this.addressCity]        
          this.addressSlots[2].values = areaList
          this.addressArea = areaList[0]
          break
        case 1:      
          this.addressCity = value
          var arr1 = address[this.addressProvince][value]          
          this.addressSlots[2].values = arr1
          this.addressArea = arr1[0]
          break
        case 2:
          this.addressArea = value          
          break
      }

      window.localStorage.ProductDetailDeliveryProvinceCache =this.addressProvince
      window.localStorage.ProductDetailDeliveryCityCache = this.addressCity
      window.localStorage.ProductDetailDeliveryAreaCache = this.addressArea
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
    },
    getPinTuanInfo(){      
      const ths = this;
      this.$post("/Shop/PinTuanServer/WapActivityGetInfoBySku", {skuId :this.skuId, activityId: this.activityId})
      .then(function(res) {
        if (res.IsSuccess) {     
          if(res.Data.Fskuid == ths.skuId){           
            ths.pinTuanInfo = res.Data
            ths.pintuanMaxnum = ths.pinTuanInfo.FmaxNum
            ths.openModel = 'pintuan'
          }else{
            ths.openModel = 'retail'
          }
        }else{          
            ths.openModel = 'retail'
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getPintuanSkuid(){
      const ths = this;
      this.$post("/Shop/PinTuanServer/WapActivityGetInfoBySku", {skuId :this.skuId,activityId: this.activityId})
      .then(function(res){
        if(res.IsSuccess){
          for(var i = 0;i<res.Data.FskuList.length;i++){
            var a = res.Data.FskuList[i].Fskuid
            ths.pintuanSkuId.push(a)
          }
        }
      })
      .catch(function(err){
        console.log(err)
      })
    },
    getProductDetail:function(){
      this.$refs.XRtoast.load()
      if(this.activityId){
        this.getPinTuanInfo()
      }
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetProductDetail",
        JSON.stringify({skuId:this.skuId, sessionId: this.$store.state.user.SessionId})
      ).then(function(res) {  
        ths.datalock = false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.productInfo = res.Data
          ths.couponInfo.ProductId =  ths.productInfo.ProductId
          ths.couponInfo.ShopId = ths.productInfo.ShopId
          ths.isZiTi = ths.productInfo.IsZiTi
          if(ths.productInfo.DiscountInfo){
              ths.productInfo.Stock = ths.productInfo.DiscountInfo.Stock
              ths.productInfo.Stock = ths.productInfo.DiscountInfo.Stock

            if(ths.productInfo.DiscountInfo.DiscountType == 1){            
              ths.endTime = ths.productInfo.DiscountInfo.EndTimeCalcName
              ths.calcDesc = "距离结束还剩"
            }            
            else if(ths.productInfo.DiscountInfo.DiscountType == 2){            
              ths.startTime = ths.productInfo.DiscountInfo.StartTimeCalcName
              ths.calcDesc = "距离开始还有"
            }            
            else if(ths.productInfo.DiscountInfo.DiscountType == 3){            
              ths.startTime = ths.productInfo.DiscountInfo.StartTimeCalcName
              ths.calcDesc = "明日预告"
            }
            ths.buynowInterval = setInterval(ths.countdownEvent, 1000)
          }
          ths.skuTabList = []
          if(ths.productInfo.AttrList){
            for(var i = 0; i< ths.productInfo.AttrList.length;i++){
              var attr = ths.productInfo.AttrList[i]
              
              for(var j = 0; j< attr.Values.length;j++){
                var attrValue = attr.Values[j]
                var attrSelect = {}
                attrSelect.attrId = attr.Id
                attrSelect.isClick = 0
                attrSelect.isCache = 0 //缓存点击记录
                attrSelect.IsSkuValue = attrValue.IsSkuValue 
                attrSelect.attrValueId = attrValue.Id
                if (attrSelect.attrValueId == 0){
                  attrSelect.attrValueUserDefine = attrValue.Name
                }
                ths.skuTabList.push(attrSelect)
              }
            }
          }
          console.info(JSON.stringify(ths.skuTabList))
          ths.getEvaluateList(function(){
            ths.evaluateCount = ths.evaluateList;
          }) 

          ths.WapCouponListByGoods()
          ths.getShopFavState(ths.productInfo.ShopInfo.ShopId)
          ths.getSiteInfo()      
        }
      });
    },
    getEvaluateList(callback){
      var ths = this;   
      ths.$refs.XRtoast.load('加载中...',false)
      var json = {skuId:this.skuId, TypeId: this.activeThreeTab,pageSize:15}
      ths.$post(
        "/Shop/RetailServer/GetProductEvaluateList",
        json
      ).then(function(res) {
         ths.loaded= false
         ths.$refs.XRtoast.hide()
         if(!res.IsSuccess){
          ths.evaluateList = {}
          //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.evaluateList = res.Data  
          callback()       
          ths.loaded= false
        }
      });
    },
    goToEvaluatePage(){
      this.$router.push('/retail/productDetailEvaluate?skuId='+this.skuId)
    },
    getFreightWeightByCode(){      
        var ths = this;   
        var data = {
          Skus:[{skuId:this.skuId,count:this.skuCount}],
          ShoppingMethod: 1, 
          ProvinceCode: this.addressProvince, 
          CityCode: this.addressCity, 
          AreaCode: this.addressArea 
        };
        ths.$post(
          "/Shop/RetailServer/GetFreightByAddressCode", data
        ).then(function(res) {
          if(res.IsSuccess){
            ths.deliveryMoney = res.Data
          }else{
            ths.deliveryMoney = ''
          }
        });
    },
    GetSelfPickUpSiteShopList(){      
        var ths = this;   
        var data = {
          SkuId:this.skuId,
          Province: this.addressProvince, 
          City: this.addressCity, 
          Area: this.addressArea 
        };
        ths.$post(
          "/Shop/RetailServer/GetSelfPickUpSiteShopList", data
        ).then(function(res) {
          if(res.IsSuccess){
            ths.selfPickUpList = res.Data
            ths.selfPickUpListDesc = res.Msg
          }else{
            ths.selfPickUpList = []
            ths.selfPickUpListDesc = res.Msg
          }
        });
    },
    getShopFavState(shopId){  
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsFavorite", {'shopId':shopId , 'favType': 2})
      .then(function(res) {
        ths.shopFavState = res.IsSuccess
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    FavStore(shopId){  
      const ths = this;
      this.$post("/Shop/StoreServer/AddShopsFavorite", {'shopId':shopId , 'favType': 2})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.shopFavState = true
        }else{
          ths.$refs.XRtoast.failed(res.Msg, true)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    UnFavStore(shopId){  
      const ths = this;
      this.$post("/Shop/StoreServer/CancelShopsFavorite", {'shopIds':[shopId] , 'favType': 2})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.shopFavState = false
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getCartCount(){
      this.cartCount =cart.getCount().toString()
    },
    GoHistory(){
      this.$router.goBack()
    },
    handleTabChange (val) {
      var ths =this
      ths.activeTab = val
      if(ths.activeTab == "tab3"){
        ths.getEvaluateList(function(){
          ths.evaluateCount = ths.evaluateList;
        })        
      }
    },
    handleSubTabChange (val) {
      this.activeSubTab = val
    },
    handleThreeTabChange (val) {
      this.activeThreeTab = val
      this.getEvaluateList()
    },
    handleActive () {
    },    
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    closeShareSheet () {
      this.shareSheet = false
    },
    openShareSheet () {
      var appClient = window.localStorage.appClient
      if(appClient == 'ios'){      
        window.webkit.messageHandlers.ajax.postMessage({fun:'share',Ftitle: this.shareTitle,Fimage:this.shareImgUrl ,FjumpUrl: this.shareLinkUrl})
      }else{
        this.shareSheet = true
      }
    },
    openShare(){
        this.shareSheet = true
    },
    joinCart(){
      this.closeAttrSheet()
      if(this.productInfo.State != 0){
        this.$refs.XRtoast.failed("即将上架，敬请期待.", true)
        return
      }      
      var cartCount = 0;
      var cartItem = cart.getItem(this.productInfo.SkuId)
      if(cartItem.count){
        cartCount = cartItem.count;
      }
      if(cartCount+this.skuCount > this.productInfo.Stock){
        this.$refs.XRtoast.failed("库存不足", true)
        return
      }
      cart.addItem(this.productInfo.SkuId, this.skuCount)
      this.getCartCount()
      this.$refs.XRtoast.success("添加成功", true)
    },
    openAttrSheet(type){
      this.attrSheet = true
      this.attrSheetType = type
    },
    closeAttrSheet(){
      this.attrSheet = false
    },
    openCouponSheet(){
      this.couponSheet =true
    },
    closeCouponSheet(){
      this.couponSheet =false
    },
    openGroupSheet(groupId){
      this.botton=2
      this.GroupSheet = true
      this.joinGroupId = groupId
    },
    openGroupSheet2(type){
      this.attrSheetType = type
      if(this.productInfo.State==0){
        if(this.pinTuanInfo.Fstock==0){
          this.$refs.XRtoast.failed("库存不足", true)
          this.GroupSheet = false
        }else if(this.pinTuanInfo.FmaxNum==0){
          this.$refs.XRtoast.failed("限购此商品", true)
          this.GroupSheet = false
        }else{
          this.botton=1
          this.GroupSheet = true    
        }
        
      }
      else{
        this.$refs.XRtoast.failed("商品已下架", true)
        this.GroupSheet = false
      }
      
    },
    closeGroupSheet(){
      this.GroupSheet = false
    },
    openGroup(){
      this.$router.push('/groupShop/groupShopSubmit?skuId='+this.productInfo.SkuId+'&activityId='+this.activityId+'&count='+this.skuCount)
    },
    joinGroup(){
      this.$router.push('/groupShop/groupShopSubmit?skuId='+this.productInfo.SkuId+'&activityId='+this.activityId+'&groupId='+this.joinGroupId+'&count='+this.skuCount)
    },
    
    skuTab(attrId, attrValueId, attrValueName){
      
      var isSelect = this.getSkuClassSelect(attrId, attrValueId,attrValueName)
      if(isSelect!='' && isSelect != 'canSelect'){
        return;
      }

      console.info(JSON.stringify('datalock：'+this.datalock))
      if(this.datalock == false){
        this.datalock = true
        var isTab = false     
        for(var i = 0; i < this.skuTabList.length;i++){
          var sku = this.skuTabList[i]
          sku.isClick= 0
        }
        for(var i = 0; i< this.skuTabList.length;i++){
          //clearTimeout(this.timer)
          var sku = this.skuTabList[i]
          if(attrId == sku.attrId){
            if(attrValueId >0 && attrValueId == sku.attrValueId || attrValueName == sku.attrValueUserDefine){
              sku.isClick= 1
              sku.isCache = 1
              sku.IsSkuValue= 1
              //this.timer = setTimeout(()=>{
                isTab = true 
                this.getAttrValue(isTab)       
              //},500) 
            }else{
              sku.isCache = 0
              sku.IsSkuValue= 0
            }
          }
        }       
      }
    },
    getAttrValue(isTab){
      console.log(isTab)
      if(isTab){
        var ths = this;  
        
        var clickSkuAttrId = 0
        var selectSku = []
        for(var i = 0; i< this.skuTabList.length;i++){
          var curSku = this.skuTabList[i]
          if(curSku.isClick == 1){
            selectSku.push(curSku)
            clickSkuAttrId = curSku.attrId
          }
        }
        for(var i = 0; i< this.skuTabList.length;i++){
          var curSku = this.skuTabList[i]
          if(curSku.IsSkuValue){
            var isContain = false
            for(var j = 0; j < selectSku.length;j++){
              if(curSku.attrId == selectSku[j].attrId){                  
                isContain=true
              }
            }
            if(!isContain){
              selectSku.push(curSku)
            }
          }
        }


        ths.$post(
          "/Shop/RetailServer/GetSkuByAttrValue",
          JSON.stringify({ productId:this.productInfo.ProductId, attrValues: selectSku})
        ).then(function(res) {    
          if(!res.IsSuccess){     
            ths.datalock = false
            if(res.TypeId != 1){
              ths.$refs.XRtoast.failed(res.Msg, true)
            }
            if(res.Data){
              for(var k = 0; k < ths.skuTabList.length;k++){
                var sku = ths.skuTabList[k]
                sku.isCan = 0
                for(var i =0; i< res.Data.length; i++){
                  if(sku.attrId == res.Data[i].AttrId ){
                    if(res.Data[i].Values){                    
                      for(var j =0; j< res.Data[i].Values.length; j++){
                        if(
                            res.Data[i].Values[j].AttrValueId> 0 && sku.attrValueId == res.Data[i].Values[j].AttrValueId
                            || res.Data[i].Values[j].AttrValueId ==0 && sku.attrValueUserDefine == res.Data[i].Values[j].AttrValueUserDefine
                        ){
                          if(clickSkuAttrId != sku.attrId){
                            sku.isCan = 1
                            ths.skuTabMode = 'can'
                          }
                        }
                      }
                    }
                  }
                }
              }
              var tempData ={attrId:-999999}
              ths.skuTabList.push(tempData)
              ths.skuTabList.splice(ths.skuTabList.length-1)
            }
            console.info(JSON.stringify(ths.skuTabList))
          }else{   
            ths.skuTabMode= 'select'             
            ths.skuId=res.Msg
            ths.getProductDetail()
          }         
        })    
      }
    },
    getPintuanSku(attrSkuId){
      for(var j=0; j<this.pintuanSkuId.length; j++){
        for(var k= 0; k < attrSkuId.length;k++){
          if(this.pintuanSkuId[j] == attrSkuId[k]){
            return 'attrStyle'
          }
        }
      }
      return ''
    },
    getSkuClassSelect(attrId,attrValueId, attrValueName){
      if(this.datalock == false){
        for(var i = 0; i< this.skuTabList.length;i++){
          var sku = this.skuTabList[i]
          if(attrId == sku.attrId && attrValueId == sku.attrValueId){  
            if((attrValueId>0 && attrValueId == sku.attrValueId || attrValueName == sku.attrValueUserDefine)){
              console.info(this.skuTabMode)

              if(this.skuTabMode == 'can'){
                if(sku.isClick==1){
                  return 'select'
                }else if(sku.isCache==1){
                  return 'select'
                }else if(sku.isCan==1){
                  return 'canSelect'
                }else{
                  return 'cannotSelect'
                }
              }else{
                if(sku.IsSkuValue==1){
                  return 'select'
                }
              }
            }       
          }
        }
      }
      return ''
    },
    plusCartItem: function(skuId , stock){
      if(this.openModel == 'retail' || this.attrSheetType==2){  //零售模式，或者是拼团里的单件购买
        if(this.skuCount+1 > stock ){
          this.closeAttrSheet()
          this.$refs.XRtoast.failed("不能再加了", true);
          return;
      }
      this.skuCount++ 
      }else if(this.openModel == 'pintuan'){
        
          if(this.skuCount+1 >this.pintuanMaxnum){
            this.tipShow = true
            this.$refs.XRtoast.failed("不能再加了", true);
            return
          }
        
        this.skuCount++ 
      }
      
    },
    minusCartItem: function(skuId , stock){
      if(this.skuCount-1 < 1){
        this.closeAttrSheet()
        this.closeGroupSheet()
        this.$refs.XRtoast.failed("不能再减了", true);
        return;
      }
      this.skuCount--
      if(this.skuCount <= this.pintuanMaxnum){        
        this.tipShow = false
      }
    },
     
    countdownEvent : function () {
        //结束倒计时
        if (this.endTime) {
            var ts = (new Date(this.endTime)) - (new Date()); //计算剩余的毫秒数    
            if (ts <= 0) {
                clearInterval(this.buynowInterval);
                return;
            }
            this.calcTime(ts);
            return;
        }

        //开始倒计时
        var startTime = this.startTime;
        if (startTime) {
            var ts = (new Date(startTime)) - (new Date()); //计算剩余的毫秒数    
            if (ts <= 0) {
                clearInterval(this.buynowInterval);
                return;
            }
            this.calcTime(ts);
            return;
        }
    },
    calcTime : function (ts) {
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数  

        this.hour1 = parseInt(hh / 10);
        this.hour2 = hh % 10;
        this.mm1 = parseInt(mm / 10);
        this.mm2 = mm % 10;
        this.ss1 = parseInt(ss / 10);
        this.ss2 = ss % 10;
    },
    goBuy(){
      var skuId = this.skuId
      this.closeAttrSheet()
      if(this.productInfo.State != 0){
        this.$refs.XRtoast.failed("即将上架，敬请期待.", true)
        return
      } 
      this.$router.push('/retail/orderSubmit?skuId='+skuId+'&count='+ this.skuCount)
    },
    goBawBuy(){
      var skuId = this.skuId
      this.closeAttrSheet()
      if(this.productInfo.State != 0){
        this.$refs.XRtoast.failed("即将上架，敬请期待.", true)
        return
      } 
      this.$router.push('/retail/orderSubmit?skuId='+this.productInfo.BuyBawAuthNewSkuId+'&count=1')
    },
    getRecommendInfo(){
      if(this.$route.query.memberId){
        var ths = this;   
        ths.$post(
          "/Shop/UserServer/GetSalesmanSettingById",
          {memberId: ths.$route.query.memberId}
        ).then(function(res) {
          if(res.IsSuccess){         
            if(res.Data.HeadPic){
              ths.recommendImage = res.Data.HeadPic
            }  
            ths.recommendText= res.Data.NickName
          }
        });
      }
    },
	goToCouponUsing(id){
		this.$router.push('/retail/coupon/couponUsingRemark?id='+id)
    },
    getUserInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
         if(res.IsSuccess){
           ths.initWeiXin(res.Data)
        }else{
          
          ths.$refs.XRtoast.hide()
          ths.loaded= false
        }
      });
    },
    initWeiXin(userInfo){
      var ths = this;   
      
      ths.shareTitle = ths.productInfo.ProductName
      ths.shareDesc = "￥"+ths.productInfo.SalePriceName +"，我在旭日购发现了一个不错的商品，赶快来看看吧"
      ths.shareImgUrl = ths.MOBILE_URL + '/static/salesman/tuiguang/share.png'
      if(ths.productInfo.ImgList && ths.productInfo.ImgList.length>0){
        ths.shareImgUrl = ths.productInfo.ImgList[0].ImgPath
      }
      ths.shareLinkUrl = ths.MOBILE_URL + '/#/retail/productDetail?skuId='+ths.skuId+'&activityId='+ths.activityId+'&memberId='+userInfo.Id
      
      var openId = wechatCache.getOpenId()
      if(!openId){
        //this.$refs.XRtoast.failed('未获取微信信息', true)
        return
      }

      ths.$postBase(
      ths.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{   
          
          ths.$refs.XRtoast.hide()
          ths.loaded= false
          
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {              
              wx.onMenuShareTimeline({
                  title: ths.shareTitle, // 分享标题
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });

              wx.onMenuShareQQ({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });

              wx.onMenuShareAppMessage({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });
              wx.onMenuShareQZone({
                  title: ths.shareTitle, // 分享标题
                  desc: ths.shareDesc, // 分享描述
                  link: ths.shareLinkUrl, // 分享链接
                  imgUrl: ths.shareImgUrl, // 分享图标
                  success: function () {
                      // 用户确认分享后执行的回调函数
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数
                  }
              });
          });
      }
      }); 
    },    
    appWeChatFringtShareClick(){
      console.log(this.shareTitle)
      console.log(this.shareDesc)
      console.log(this.shareImgUrl)
      console.log(this.shareLinkUrl)
      appShare.shareWeChatFriend(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    },    
    appWeChatFringtQuanShareClick(){
      appShare.shareWeChatFriendQuan(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
    },
    goToEvaluateImg(skuId, imgId){
      this.$router.push('/retail/productDetailImg?skuId='+skuId + '&imgId='+imgId)
    },
    zhekou(price, saleprice){
      var zk = price/saleprice
      var showZk = zk.toFixed(2)
      if(showZk<0.01){
        showZk =zk.toFixed(3)
        if(showZk < 0.001){
          showZk =zk.toFixed(4)
        }
      }
      return showZk
    },
    goLogin(){
      var redirectUrl = window.location.hash
      redirectUrl = redirectUrl.replace('#','')
      this.$router.push('/login?redirect='+ redirectUrl)
    }
  },
  watch:{
    address(){    
      this.deliveryAddress = this.addressProvince + ' > ' + this.addressCity + ' > ' +this.addressArea

      if(this.addressProvince != '全部' && this.addressCity != '全部' && this.addressArea != '全部'){
        this.getFreightWeightByCode()
      }
    }
  }
}
</script>

<style>
.productDetail {  
  padding-bottom: 112px;
}
.productDetail .XR-tab-head{
  height: 48px;
}
.productDetail .XR-tab-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
  z-index: 10;
}
.productDetail .XR-tab-head .mu-appbar-title {
  font-size: 16px;
}
.productDetail .XR-tab-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.productDetail .XR-tab-head .title .title-text {
  margin: 0;
  line-height: 48px;
}

.productDetail .XR-tab-head .recommendText{
  float:left;
  font-size: 12px;
  height: 39px;
  padding-top: 9px;
  overflow: hidden;
  
}
.productDetail .XR-tab-head .recommendText p{
  word-break:break-all;
  word-wrap:break-word;
  white-space:normal;
  line-height: 15px;
  padding-left:10px;
  height: 30px;

}
.productDetail .XR-tab-head .recommendImg{
  float:left;
  width: 30px;
  height: 48px;
  padding-top: 9px;
}
.productDetail .XR-tab-head .recommendImg img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.productDetailServiceInfo{
  background: #fff;
  padding: 16px;
}

.productDetail .baseInfo{  
  padding-bottom: 56px;
  padding-top: 48px;
}
.productDetail .baseInfo .noticeToLogin{  
  padding: 10px 10px;
  font-size: 14px;
  background:#ebf19c;
  color:#999;
  line-height: 14px;
}
.productDetail .baseInfo .noticeToLogin i{
  color:#999;
}
.productDetail .XR-tab-head .head-content{
  overflow: hidden;
  line-height: 48px;
}
.fontImgInfo{
  margin-bottom: 56px;
}
.fontImgInfo p{
  padding: 8px 16px;
  background: #fff;
}
.productDetailImgInfo p:first-child{
  
}

.productDetail .pic-carousel {
  width: 100%;
  position: relative;
}
.productDetail .pic-carousel .show-img {
  overflow: hidden;
}
.productDetail .pic-carousel .show-img img{
  display: block;
}
.productDetail .pic-carousel .img-count{
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: #ddd;
  padding:0 10px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  color:white;
}


.productDetail .pro-activity{
  background:url('/static/us-top-bg.png') left center; 
  height:50px;
}
.productDetail .pro-activity .activity-discountPrice{
  float:left; 
  line-height:50px;
  font-size:24px;
  font-weight:700;
  color:white;
  overflow: hidden;
  margin-left: 10px;
  height: 50px;
}
.productDetail .pro-activity .activity-discountPrice .fontIcon{
  font-size:12px;
  letter-spacing: -3px;
}
.productDetail .pro-activity .sale-price{
  float:left; 
  padding:8px 0 8px 15px;
}
.productDetail .pro-activity .sale-price .price-num{
  line-height:16px;
  font-size:14px;
  color:white;
  text-decoration: line-through;
  padding-bottom: 2px;
}
.productDetail .pro-activity .sale-price .desc{
  line-height:14px;
  font-size:14px;
  color:white; 
  border:1px solid white;
}
.productDetail .pro-activity .sale-price .desc i{
  background:white;
  color:red;
}
.productDetail .calc-time{
  float:right;
  width: 120px;
  height: 50px;
  background: #efefef;
  color:#666;
}
.productDetail .calc-time .desc{
  text-align: center;
  line-height: 20px;
  height: 20px;
  font-size: 12px;
}
.productDetail .calc-time .countdown{
  text-align: center;
}
.productDetail .calc-time .countdown .time{
  font-size:18px; 
  width:12px; 
  height:23px; 
  line-height: 23px;
  text-align:center; 
  background:url(/static/active/countdown.png) no-repeat; 
  color:white;
  display: inline-block;
}
.productDetail .calc-time .countdown .font{
   font-size:12px; 
   width:1px; 
   text-align:center; 
   color:#666;
  display: inline-block;
}
.productDetail .pro-info{
  background: white;
  padding: 10px 10px;
  font-size: 12px;
}
.productDetail .pro-info .price-count{
  font-size: 14px;
  overflow: hidden;
  line-height: 30px;
  margin-top: 10px;
}
.productDetail .pro-info .price-count .sign{
  text-align: center;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  padding: 1px 0;
  overflow: hidden;
  height: 20px;
  line-height: 20px;
  border-radius: 3px;
  margin-top: 5px;
}
.productDetail .pro-info .price-count .shopNum{
  background: #EB4D54;
  width: 40px;
  margin-right: 10px;
  float: left;
  margin-left: 10px;
}
.productDetail .pro-info .price-count .free_post{
  float: left;
  width: 40px;
  margin-right: 10px;
  background: #CC9137;
}
.productDetail .pro-info .price-count .price{
  font-size: 14px;
  color: #C13B38;
  float: left;
}
.productDetail .pro-info .price-count .price span{
  font-size: 20px;
}
.productDetail .pro-info .price-count .sellCount{
  float: right;
  font-size: 12px;
  color: #999;
}
.productDetail .pro-info .discount-price{
  color: #CB5A57;
  font-size: 14px;
  float: left;
  font-weight: bold;
}
.productDetail .pro-info .cost-price{
  color: #888;
  font-size: 14px;
  float: left;

}
.productDetail .pro-info .pro-name{
  line-height: 25px;
  overflow: hidden;
  font-size: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  /*display: -webkit-box;*/
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.productDetail .pro-info .pro-name .pro-left{
  float: left;
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.productDetail .pro-info .pro-name .pro-right{
  float: left;
  width: 10%;
  text-align: center;
  border-left: 1px solid #eee;
  height: 50px;
  line-height: 50px;
}
.productDetail .pro-info .pro-name .pro-left .pro-title{
  float: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bold;
  padding: 0 5px;
  width: 100%;
}
.productDetail .pro-info .pro-desc{
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
  font-size: 12px;
  color: #888;
  margin-top: 10px;
}

.productDetail .pro-info .pro-price{
  margin-top: 10px;
  overflow: hidden;
}
.productDetail .pro-info .pro-price .sale-price{
  color:red;
  font-size: 20px;
  line-height: 20px;
}
.productDetail .pro-info .pro-price .sale-price .fa{
  font-size: 14px;
}
.productDetail .pro-info .pro-price .del-price{
  font-size: 12px;
  float: left;
  text-decoration: line-through;
  color:#999;
}
.productDetail .pro-row{
  margin-top: 10px;
  background: white;
  padding: 10px 0 10px 10px;
  line-height: 28px;
  overflow: hidden;
  width: 100%;
}
.productDetail .pro-row .group-title{
  font-size: 12px;
  float: left;
  margin-right: 40px;
  color: #000;
}
.productDetail .pro-row .pro-title{
  width: 50px;
  font-size: 14px;
  color:#999;
  float: left;
}
.productDetail .coupon .pro-content{
  word-break: break-word;
  height: 28px;
  overflow: hidden;
}
.productDetail .coupon .pro-content .discount-coupon{
  position: relative;
  display: inline-block;
  margin-right: 5px;
  padding: 0 9px 0 12px;
  border-top: 1px solid #e4393c;
  border-bottom: 1px solid #e4393c;
  height: 18px;
  line-height: 16px;
  color: #e4393c;
  font-size: 10px;
}
.productDetail .coupon .pro-content .discount-coupon:after,.productDetail .coupon .pro-content .discount-coupon:before{
    content: "";
    position: absolute;
    top: -1px;
    height: 18px;
    background-image: url('../../../static/coupon.png');
    background-size: 15px 18px;
    background-repeat: no-repeat;
}
.productDetail .coupon .pro-content .discount-coupon:before{
  left: 0px;
  width: 7px;
}
.productDetail .coupon .pro-content .discount-coupon:after{
  right: 0px;
  width: 4px;
  background-position: -11px 0px;
}
.productDetail  .stepImg{
  width: 100%;
  padding: 10px 10px;
  background: #fff;
  border-top: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
}
.productDetail  .stepImg img{
  width: 98%;
}
.productDetail .buyCount{
  padding: 10px 10px;
  background: #fff;
  color: #C13B38;
  margin-top: 15px;
  font-size: 12px;
}
.productDetail .goShop{
  padding: 10px 10px;
  background: #fff;
  margin-top: 15px;
}
.productDetail .goShop .shop-pro{
  font-size: 12px;
  color: #999;
}
.productDetail .goShop .proMessage{
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
}
.productDetail .goShop .proMessage .clonel{
  width: 44px;
  height: 44px;
  border: 1px solid #FAC424;
  position: relative;
  display: inline-block;
  text-align: center;
  margin-right: 4px;
  border-radius: 50%;
  float: left;
}
.productDetail .goShop .proMessage .name-count{
  float: left;
  margin-left: 10px;
  width: 67%;
}
.productDetail .goShop .proMessage .shopBtn{
  float: right;
}
.productDetail .goShop .proMessage .shopBtn .mu-flat-button{
  border: 1px solid #C13B38;
  min-width: 50px;
  height: 25px;
  line-height: 25px;
}
.productDetail .goShop .proMessage .shopBtn .mu-flat-button .mu-flat-button-label{
  padding: 0;
  font-size: 12px;
  color: #C13B38;
}
.productDetail .goShop .proMessage .name-count .shopName{
  font-size: 14px;
  color: #000;
}
.productDetail .goShop .proMessage .name-count .shopCount{
  font-size: 12px;
  color: #999;
}
.productDetail .goShop .proMessage .name-count .shopCount span{
  padding: 0 3px;
  color: red;
}
.productDetail .goShop .proMessage .clonel img{
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.productDetail .goShop .proMessage .clonel .tuanzhang{
  position: absolute;
  left: 6px;
  bottom: -5px;
  color: #fff;
  background: #EB4D54;
  border-radius: 5px 5px;
  padding: 0 4px;
  font-size: 10px;
  height: 18px;
  line-height: 18px;
}
.productDetail .pro-row .pro-content{
  width: 40px;
  font-size: 12px;
  color:#999;
  float: left;
  color:black;
}
.productDetail .pro-row .pro-content .strone{
 
}
.productDetail .pro-row .pro-content .mu-raised-button{
  box-shadow: none;
}

.demo-popup-bottom{width: 100%;}
.demo-popup-bottom .selfPickUpShopList{max-height: 400px; overflow-y: scroll;}
.demo-popup-bottom .item-content p{
  line-height: 25px;
}
.demo-popup-bottom .item-content .name{
  color: #000;
}
.demo-popup-bottom .item-content .address,.demo-popup-bottom .item-content .phone{
  font-size: 12px;
  color: #666;
}
.productDetail .pro-row .pro-content .item{
  overflow: hidden;
  font-size: 14px;
}
.productDetail .pro-row .pro-content .item .fontIcon{
  float: left;
  font-size: 12px;
  background: red;
  text-align: center;
  color:white;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin: 7px 1px;
}
.productDetail .pro-row .pro-content .item .text{
  float: left;
  margin-left: 10px;
}
.productDetail .pro-row .pro-icon{
  width: 20px;
  font-size: 12px;
  color:#999;
  float: left;
  text-align: center;
}

.productDetail .id-shop { overflow:hidden; margin:10px 0; background:white;}
.productDetail .id-shop .logo { overflow:hidden; padding:0px 15px 0px;height: 40px;display: flex;align-items: center;margin-top: 10px;}
.productDetail .id-shop .logo img { display:block; float:left; width:40px;object-fit: cover;max-height: 40px;}
.productDetail .id-shop .logo .shop-name { float:left; margin-left:10px;}
.productDetail .id-shop .total-count { overflow:hidden;margin-top: 10px;}
.productDetail .id-shop .total-count .item { float:left; width:50%; text-align:center; position:relative; font-size:22px;color: #ff4981;}
.productDetail .id-shop .total-count .item.border:after { content:''; position:absolute; top:4px; height: 28px; right:0; bottom:0; width:1px; background:#ddd;}
.productDetail .id-shop .total-count .item .desc { color:#999;font-size: 12px;}
.productDetail .id-shop .shop-btns { overflow:hidden; height:60px;}
.productDetail .id-shop .shop-btns .btn-item { width:33%; float:left; text-align:center; line-height:60px;}
.productDetail .id-shop .shop-btns .btn-item .link-btn {border:1px solid #dedede; padding:8px 15px; border-radius:5px; font-size:12px; color:#000;}
.productDetail .id-shop .shop-btns .btn-item .link-btn .fa{color: #999;} 


.productDetail .productDetailImgInfo{
  margin-top: 10px;
  overflow: hidden;
  padding: 0 10px;
  background: #fff;
}
.productDetail .productDetailImgInfo img{
  width: 100%;
  display: block;
}

.productDetail-skuSaleInfo {
  height: 75px;
}
.productDetail-skuSaleInfo .pro-img{
  float: left;
}
.productDetail-skuSaleInfo .img{
  margin-top:-15px;
  margin-left: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  width: 80px;
  display: block;
  height: 80px;
  object-fit: cover;
}
.productDetail-skuSaleInfo .info{  
  float: left;
  padding: 20px 0 0 15px;
}
.productDetail-skuSaleInfo .info .price{  
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color:Red;
}
.productDetail-skuSaleInfo .info .skuid{ 
  font-size: 12px;
}

.productDetail-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 250px;
}
.productDetail-attrList {
  overflow: hidden;
}
.productDetail-attrList .attr{  
  border-top:1px solid #eee;
  padding: 0 10px;
}
.productDetail-attrList .attr .attrName{
  line-height: 34px;
}
.productDetail-attrList .attr .attrValueList{
  overflow: hidden;
}
.productDetail-attrList .attr .attrValueList .attrValue{
  float: left;
  padding: 5px 20px;
  margin: 0 10px 10px 0;
  background: #eee;
  color: #000;
  border-radius: 5px;
  overflow: hidden;
}
.productDetail-attrList .attr .attrValueList .attrValue .attrIcon{
  width: 20px;
  height: 20px;
  margin-right:5px;
  float: left;
}
.productDetail-attrList .attr .attrValueList .attrValue .attrValueText{
  float: left;
}
.productDetail-attrList .attr .attrValueList .attrValue.disabled{
  background: #eee;
  color:#ddd;
}
.productDetail-attrList .attr .attrValueList .attrValue.select{
  background: red;
  color:white;
}
.productDetail-attrList .attr .attrValueList .attrValue.canSelect{
  border:1px solid #ccc;
  color:black;
}
.productDetail-attrList .attr .pintuanAttr .attrValue:not(.attrStyle) {
  pointer-events:none;
  cursor: not-allowed;
  border:1px dashed #ccc;
  color:#ccc;
}
.productDetail-attrList .attr .pintuanAttr .attrValue.canSelect:not(.attrStyle) {
  pointer-events:none;
  cursor: not-allowed;
  border:1px dashed #ccc;
  color:#ccc;
}
.productDetail-attrList .attr .attrValueList .attrValue.cannotSelect{
  border:1px dashed #ccc;
  color:#ccc;
}
.productDetail-attrList .attr .attrValueList .attrValue.select .attrIcon{
  border:1px solid white;
}
.productDetail-jiajian{
  overflow: hidden;
}
.productDetail-scroll .tip{
  float: left;
  padding: 20px 10px;
  color: red;
}
.productDetail-jiajian-ctrl{
  padding: 20px 10px;
  float: right;
}
.productDetail-jiajian-ctrl span{
  float: left;
  width: 20px;
  text-align: center;
}
.productDetail-jiajian-ctrl .count{
  border: 1px solid #eee;
  width: 30px;
  border-left: 0;
  border-right: 0;
}
.productDetail-jiajian-ctrl .btn{
  border: 1px solid #eee;
}
.productDetail-jiajian-ctrl .jian{
  border-radius:2px 0 0 2px;
}
.productDetail-jiajian-ctrl .jia{
  border-radius:0 2px 2px 0;
}
.productDetail-btn .btn{
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: red;
  color: white;
}

.productDetail .pro-row.delivery-info {
}
.productDetail .pro-row.delivery-info .item .fa{
  width: 15px;
  color:#ff4981;
  font-size: 14px;
}
.productDetailInfo{
  background: white;
  padding-top: 48px;
}
.productDetailInfo .fontImgInfo img{ width: 100%; display: block;}
.productDetail .specListDiv{
  background: white;
  overflow: hidden;
  margin-bottom: 15px;
}
.productDetail .specListDiv .specListTitle{
  text-align: center;
  margin-top: 10px;
}
.productDetail .specList{
  border-left:1px solid #eee;
  border-top:1px solid #eee;
  width: 95%;
  margin: 10px auto;
  text-align: center;
}
.productDetail .specList td{
  border-right:1px solid #eee;
  border-bottom:1px solid #eee;
  line-height: 32px;
  font-size: 12px;
  color: #999;
}
.productDetail .specItemName{
  width: 40%;
}
.productDetail .specItemValue{
  width: 60%;
}


.productDetailEvalue{
  background: white;
  padding-top: 48px;
}
.productDetail .id-sumary{
  background: white;
}
.productDetail .id-sumary ul li{
  padding:1rem 0.5rem;
  list-style: none;
}
.productDetail .id-sumary ul li .mu-divider{
  background-color: #f5f5f5; 
}
.productDetail .id-sumary ul li .timg{
  width: 9%;
  float: left;
  display:flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}
.productDetail .id-sumary ul li .timg img{
  width: 100%;
  height: 100%;
}
.productDetail .id-sumary ul li:last-child{
  box-shadow:none;
}
.productDetail .id-sumary ul li .nametime{
  display: block;
  color:#000;
  font-size: .75rem;
}
.productDetail .id-sumary ul li .time{
  float: right;
  color: #999;
  font-size: 12px;
}
.productDetail .id-sumary ul li p{
  color:#5A5655;
  font-size:14px;
  line-height: 1.4;
}
.productDetail .id-sumary ul li p.content{
  clear:both;
  margin-top: 10px;
  word-wrap: break-word;
  word-break: break-all;
}
.productDetail .id-sumary ul li p.content img
{
    width:50px;
    height:50px;
}
.productDetail .id-sumary ul li .pj-img-list{
  overflow: hidden;
}
.productDetail .id-sumary ul li .pj-img-list .dimg
{
  float: left;
  overflow: hidden;
  width:32%;
  margin-top: 8px;
  display:flex;
  align-items: center;
  justify-content: center;

}
.productDetail .id-sumary ul li .pj-img-list .dimg:nth-child(n+2){
  margin-left: 2%;
}
.productDetail .id-sumary ul li .pj-img-list .dimg:nth-child(4){
  margin: 0;
  margin-top: 8px;
}
.productDetail .id-sumary ul li .pj-img-list .dimg img{
    height: auto;
    width: auto;
    max-width: 100%;
    min-height: 100%;
}
.productDetail .id-sumary .id-comments-dd{
  display: none;
  font-size: .75rem;
  line-height: 2;
  color:#5A5655;
}
.productDetail .id-sumary .id-comments-dd:nth-child(2){
  display: block;
}

.productDetail .xing-div
{
    height:18px;
    overflow:hidden;
    color:red;
    font-size: 12px;
}
.productDetail .xing-div .fa-star{
  padding: 0 2px;
}
.productDetailBottomButton{
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: white;
  border-top: 1px solid #eee;
  line-height: 56px;
  z-index: 4;
}
.productDetailBottomButton .content{
  float: left;
  width: 50%;
  padding: 12px 0;
}
.productDetailBottomButton .pintuanBtn{
  width: 100%;
  padding: 0;
  height: 100%;
}
.productDetailBottomButton .content .btn{
  float: left;
  width: 33%;
  text-align: center;
  color: #999;
  line-height: 16px;
}
.productDetailBottomButton .pintuanBtn .btn{
  height: 100%;
  width: 33%;
  padding-top: 12px;
  background: #EB4D54;
  color: #fff;
}
.productDetailBottomButton .pintuanBtn .btn:nth-child(2){
  background: #FF9500;
  width: 34%;
}
.productDetailBottomButton .content .btn.faved{
  color: red;
}
.productDetailBottomButton .content .btn a{
  color: #999;
}
.productDetailBottomButton .content .btn ~ .btn{
}
.productDetailBottomButton .btn-list{
  float: left;
  width: 50%;
}
.productDetailBottomButton .btn-list .btn{
  float: left;
  width: 50%;
  background: #FF9500;
  text-align: center;
  color:white;
}
.productDetailBottomButton .btn-list .btn ~ .btn{
  background: #FF0036;
}
.productDetailBottomButton .productDetailServiceInfo{
  background: #fff;
  padding: 1rem;
}
.productDetailBottomButton .mu-badge-container .mu-badge-float{
  right: 0;
}

.productDetailPage-shareSheetTitle {
  line-height: 40px;
  font-size: 16px;
  padding: 20px 20px 0;
}
.productDetailPage-shareSheetWayList {
  overflow: hidden;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem {
  float: left;
  padding: 20px;
  width: 100px;
  text-align: center;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayIcon {
  font-size: 28px;
  border-radius: 50%;
  width:45px;
  height:45px;
  line-height: 45px;
  text-align: center;
  color:white;
  display: inline-block;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrind{
  background: #07BD13;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrindQuan{
  background: #99D021;
}
.productDetailPage-shareSheetWayList .shareSheetWayItem .shareWayText {
  padding-top: 10px;
}


.mu-bottom-sheet .coupon_sec_body{
    width: 100%;
    padding: 10px;
    background: #f5f5f5;
    height: 50vh;
    overflow: auto;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner{
    width: 100%;
    display: flex;
    margin-top: 10px;
    background-size: 100% 100%; 
  }
.mu-bottom-sheet  .coupon_sec_body .coupon_default_inner:first-child{
    margin-top: 0;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponLeft{
    padding: 10px 0;
    background-size:100% 100%; 
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponLeft .coupon_discount{
    width: 60px;
    height: 60px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    margin: 0 8px;
    margin-top: 8px;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponLeft.couponGrey .coupon_discount{
    background: #999;
  }
.mu-bottom-sheet .coupon_sec_body .couponGrey{
  background: url('/static/coupon/couponCenter1-2.png');
}
.mu-bottom-sheet .coupon_sec_body .couponRink{
  background: url('/static/coupon/couponCenter1.png');
}
.mu-bottom-sheet .coupon_sec_body .couponYellow{
  background: url('/static/coupon/couponCenter1-3.png');
}
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponLeft.couponRink .coupon_discount{
    background: #E95E88;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponLeft.couponYellow .coupon_discount{
    background: orange;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .coupon_discount .cost{
    height: 20px;
    line-height: 30px;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .coupon_discount .money{
    font-size: 26px;
    height: 30px;
    line-height: 30px;
  }  
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight{
    background-image: url('../../../static/coupon/couponCenter2.png'); 
    background-size:100% 100%; 
    padding: 10px 0;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight .coupon_content{
    padding: 0 8px;
    border-left: 1px dotted #999;
    
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 25px;
    line-height: 23px;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title .coupon_type{
    
    padding: 2px 5px;
    font-size: 12px;
    border-radius: 3px;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_content .coupon_title .coupon_type{
    border: 1px solid #999;
    color: #999;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_content .coupon_title .coupon_type{
    border: 1px solid #E95E88;
    color: #E95E88;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_content .coupon_title .coupon_type{
    border: 1px solid orange;
    color: orange;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .limit{
    font-size: 12px;
    color: #666;
    margin: 5px 0 10px;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .coupon_progress{
    display: flex;
    align-items: center;
    position: relative;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .coupon_progress span{
    width: 50px;
    padding-left: 5px;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_progress span.percent{
    color: #999;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_progress span.percent{
    color: #E95E88;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_progress span.percent{
    color: orange;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner  .coupon_progress .mu-linear-progress{
    width: 40%;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: #999;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: #E95E88;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_progress .mu-linear-progress .mu-linear-progress-determinate{
    background: orange;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .coupon_progress .mu-flat-button{
    width: 64px;
    min-width: 64px;
    height: 26px;
    background: red;
    color: #fff;
    position: absolute;
    right: 0;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .coupon_progress .coupon_empty{
    position: absolute;
    width: 64px;
    text-align: center;
    right: 0;
    font-size: 12px;
  }
.mu-bottom-sheet .coupon_sec_body .coupon_default_inner .coupon_progress .mu-flat-button .mu-flat-button-label{
    font-size: 12px;
    padding: 0;
  }

  .payLayer{
    position:fixed;
    top:0;
    right:0;
    left:0;
    bottom:0;
    text-align:center;
    z-index:99999997;
  }
  .payLayer .payLayerBg{
    position:absolute;
    top:0;
    right:0;
    left:0;
    bottom:0;
    background:rgba(0,0,0,.5);
    z-index:99999998;
  }
  .payLayer .payLayerContent{
    width:70%;
    display:block;
    margin:200px auto 0;
    position:relative;
    z-index:99999999;
  }
  .payLayer .qrBtn{
    position:absolute;
    top:-10px;
    right:-10px;
    background:rgba(255,255,255);
    width:25px;
    height:25px;
    border-radius:50%;
  }
  .payLayer .qrBtn img{
    width:15px;
    height:15px;
    margin:5px;
  }
  .payLayer .qrcode{
    width:100%;
    display:block;
  }
  .payLayer p{
    width:100%;
    background:white;
    margin:0;
    padding:0;
    display:inline-block;
    padding-bottom:20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/productDetail.vue